import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

/** Catálogo In-house (almacenes dentro del hospital que no son locker): /inhouses. */
@Injectable({ providedIn: 'root' })
export class InhousesService extends ApiBaseService<any> {
  constructor() {
    super('inhouses');
  }
}
